<div class="cart-parts-widget" [class.active]="cartCount">
  <a (click)="goToCart()" class="icon-tag">
    <span class="tag">{{ cartCount }}</span>
    <sp-icon name="shopping-cart-2" type="solid" size="small"></sp-icon>
  </a>
  <div #parts [hidden]="!showParts" class="cart-parts" *ngIf="cartCount > 0">
    <div class="content">
      <div class="table-content">
        <div *ngIf="cart.stockParts.length">
          <h6 class="heading-6 title">القطع</h6>
          <sp-table [style]="'--zeebra'">
            <sp-table-head>
              <sp-table-head-cell>اسم القطعة</sp-table-head-cell>
              <sp-table-head-cell>الكمية</sp-table-head-cell>
              <sp-table-head-cell class="custom-no-wrap-style-2">سعر الوحدة</sp-table-head-cell>
            </sp-table-head>
            <sp-table-body>
              <ng-template ngFor let-cartPart [ngForOf]="cart.stockParts" let-i="index">
                <sp-table-body-row [class.--odd]="i % 2">
                  <sp-table-body-cell>{{ cartPart.name }} </sp-table-body-cell>
                  <sp-table-body-cell>{{ cartPart.selectedQuantity }}</sp-table-body-cell>
                  <sp-table-body-cell>{{ cartPart.unitPrice }} ريال</sp-table-body-cell>
                </sp-table-body-row>
              </ng-template>
            </sp-table-body>
          </sp-table>
        </div>
        <div *ngIf="cart.premiumQuotations.length">
          <h6 class="heading-6 second-title">طلبات التسعير</h6>
          <sp-table [style]="'--zeebra'">
            <sp-table-head>
              <sp-table-head-cell>اسم القطعة</sp-table-head-cell>
              <sp-table-head-cell class="custom-no-wrap-style">رقم القطعة</sp-table-head-cell>
            </sp-table-head>
            <sp-table-body>
              <ng-template ngFor let-cartPart [ngForOf]="cart.premiumQuotations" let-i="index">
                <sp-table-body-row [class.--odd]="i % 2">
                  <sp-table-body-cell>{{ cartPart.name }}</sp-table-body-cell>
                  <sp-table-body-cell>{{ cartPart.catalogueNumber }}</sp-table-body-cell>
                </sp-table-body-row>
              </ng-template>
            </sp-table-body>
          </sp-table>
        </div>
      </div>
    </div>
    <div class="actions">
      <sp-button class="acton-button" (clickAction)="goToCart()" [style]="'ghost positive'" [label]="'شراء ألان'"> </sp-button>
      <sp-button class="acton-button" (clickAction)="showParts = false" [style]="'ghost negative'" [label]="'إلغاء'"> </sp-button>
    </div>
  </div>
</div>
